import { useEffect } from 'react'

/**
 * Applies IntersectionObserver-based scroll-reveal to all `.reveal` elements
 * inside a container (or the whole document). Call once on mount.
 */
export function useReveal(threshold = 0.1) {
  useEffect(() => {
    const els = document.querySelectorAll('.reveal')
    if (!els.length) return

    const io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in')
            io.unobserve(entry.target)
          }
        }
      },
      { threshold },
    )

    els.forEach((el) => io.observe(el))
    return () => io.disconnect()
  }, [threshold])
}
